import type { WorksheetRules } from '../as400CellRuleKinds';

/**
 * The Item Add (additional description) worksheet's own rules, on top of its
 * columns' character limits. Append new entries; keep one ticket's entries
 * together under its comment.
 */
export const ITEM_ADD_SHEET_RULES: WorksheetRules = {
  rules: [],
  autoFills: [],
  addDefaults: [],
};
